import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    color: theme.color.greys[80],
    display: 'flex',
    flexDirection: 'column',
  },
  titleWrapper: {
    marginBottom: 16,
    '& button': {
      display: 'flex',
      justifyContent: 'flex-start',
      cursor: 'pointer',
    },
  },
  titleAndIconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 420,
    width: '100%',
    alignItems: 'flex-start',
  },
  infoBoxWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
  },
  bigBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flex: '1 1 auto',
    minWidth: 0,
    maxWidth: `calc(100% - 16px - 103px)`,
  },
  smallBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flex: '0 0 103px',
    minWidth: 103,
  },
  roiText: {
    marginBottom: 6,
  },
  ratingAolLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  tooltip: {
    marginLeft: 8,
  },
  rating: {
    marginTop: 4,
  },
  starIcon: {
    width: 16,
    height: 16,
  },
  emptyStarIcon: {
    width: 16,
    height: 16,
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
      width: '50%',
    },
  },
  horizonLabel: {
    paddingBottom: 4,
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    '& $alertCircleIcon': {
      top: 1
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },
  horizon: {
    font: fontText('normal', theme.fontSize.s, 20),
    backgroundColor: theme.color.greys[80],
    color: theme.color.greys[0],
    padding: '2px 8px',
    display: 'inline-block',
    borderRadius: 4,
    width: 'fit-content',
  },
}), { name: 'FundTile', index: StylesIndexInjections.OTHER });
